import * as React from 'react'

import { HeartEnvelopeIcon, Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-ACCEPTEDSUBSIDIES`

interface IProps {
  subsidies: any[]
}

export default function AcceptedSubsidies(props: IProps) {
  const { subsidies } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const subsidiesText = () => {
    if (Array.isArray(subsidies) && subsidies.length) {
      return subsidies.map(subsidy => (
        <Text key={subsidy.id} muted>
          {subsidy.name}
        </Text>
      ))
    } else {
      return <Text muted>{t(`${PRE}-NO-SUBS`)}</Text>
    }
  }

  return (
    <Bullet icon={<HeartEnvelopeIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      {subsidiesText()}
    </Bullet>
  )
}
